const React = require('react')
const { useHistory } = require('react-router-dom')
const { Table, UncontrolledTooltip } = require('reactstrap')
const { useResponsive, BREAKPOINTS } = require('@hooks')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/blocks/index.css')

const TokensTable = props => {
    const { data } = props

    const history = useHistory()
    const { network } = useNetworkConfig()
    const isMobile = useResponsive(BREAKPOINTS.medium)

    return (
        <Table responsive style={isMobile ? { display: 'block', overflowX: 'auto', whiteSpace: 'nowrap' } : {}}>
            <thead>
                <tr>
                    <th>#</th>
                    <th>Token</th>
                    <th>Transfers</th>
                    <th>Holders</th>
                    <th>Total Supply</th>
                </tr>
            </thead>
            <tbody>
                {data?.map((token, index) => (
                    <tr key={token.tokenAddress}>
                        <td>
                            <span style={{ fontWeight: 'bold' }}>{index + 1}</span>
                        </td>
                        <td>
                            <span
                                id={`token-${token.tokenAddress}`}
                                className={`${network.name}-text-color-after cursor-pointer`}
                                onClick={() => history.push(`/${network.name}/token/${token.tokenAddress}`)}
                            >
                                {token.tokenName}
                            </span>
                            &nbsp;
                            <span style={{ fontSize: '12px', fontWeight: 'normal', color: 'var(--grey-color)' }}>
                                ({token.tokenSymbol})
                            </span>
                            <UncontrolledTooltip placement='top' target={`token-${token.tokenAddress}`}>
                                {token.tokenAddress}
                            </UncontrolledTooltip>
                        </td>
                        <td>{token.totalTransfers.toLocaleString()}</td>
                        <td>{token.totalHolders.toLocaleString()}</td>
                        <td>
                            {(token.totalSupply / 10 ** token.tokenDecimals).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: token.tokenDecimals
                            })}
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}

module.exports = { TokensTable }
